module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/square_3x.b0292a8.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/square_3x.png
// module id = aU/1
// module chunks = 41